export default __webpack_public_path__ + "static/media/ToDoPlus.b58ffb1f.png";